import React, { useContext, useEffect, useState } from "react";
import Header from "../../CoustamComponent/Header";
import { Link, useLocation } from "react-router-dom";
import { ProfileContext } from "../../../Services/ProfileProvider";
import LoaderHelper from "../../../Services/Loading/LoaderHelper";
import AuthService from "../../../Services/ApiServices/AuthService";
import { alertErrorMessage, alertSuccessMessage } from "../../../Services/CustomAlertModel";
import { ApiConfig } from "../../../Services/ApiServices/AuthAction/ApiConfig";
// import countryName from "../../../Component/SidebarComponent/UserKyc/countryName.json"
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import moment from "moment";

const CopierArea = () => {
	const location = useLocation();
	const { wlletBalance, userDetails, handleWalletBalance } = useContext(ProfileContext);
	const [userProfitLoss, setUserProfitLoss] = useState();
	
	const [stopCopyingModel, setStopCopyingModel] = useState(false);
	const [addInvestment, setAddInvestment] = useState(false);
	const [reduceInvestment, setReduceInvestment] = useState(false);

	const [addInvestAmount, setAddInvestAmount] = useState("");
	const [reduceAmount, setReduceAmount] = useState("");

	const [masterSummeryData, setMasterSummeryData] = useState();
	
	const [activeMaster, setActiveMaster] = useState(null);
	const [masterHistoryData, setMasterHistoryData] = useState([]);
	const [masterDataLength, setMasterDataLength] = useState(10);
	const [activeTab, setActiveTab] = useState("Summary");

	const KycStatus = userDetails?.kycVerified;

	// const countryFlag = countryName.filter(flag => flag.name === userDetails?.country)[0];

	const formatNumber = (number) => {
		return new Intl.NumberFormat('en-US').format(number);
	}

	const handleCalculationMaster = async () => {
		LoaderHelper.loaderStatus(true);
		try {
			const result = await AuthService.getCalCulationMaster();
			LoaderHelper.loaderStatus(false);
			if (result?.success) {
				// alertSuccessMessage(result?.message);
				setUserProfitLoss(result);
				setMasterSummeryData(result?.data[0])
			} else {
				alertErrorMessage(result);
			};
		} catch (error) {
			alertErrorMessage(error);
		}
	};

	const handleHistoryData = async () => {
		LoaderHelper.loaderStatus(true);
		try {
			const result = await AuthService.getHistoryData();
			LoaderHelper.loaderStatus(false);
			if (result?.success) {
				const data = result?.data.flatMap((item) => {
					return [
						...(item.commissionData || []),
						...(item.depositWithdrawalData || []),
						...(item.transactions || [])
					];
				});

				const sortedData = data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

				const latestDate = new Date(sortedData[0].createdAt).toDateString();

				const latestData = sortedData.filter(item =>
					new Date(item.createdAt).toDateString() === latestDate
				);

				setMasterHistoryData(latestData);
				
				console.log("🚀 ~ handleHistoryData ~ latestD  ata:", latestData)
			} else {
				alertErrorMessage(result);
			};
		} catch (error) {
			alertErrorMessage(error);
		}
	};

	const handleStopCopying = async (id) => {
		LoaderHelper.loaderStatus(true);
		try {
			const result = await AuthService.removeMaster(id);
			LoaderHelper.loaderStatus(false);
			if (result?.success) {
				alertSuccessMessage(result?.message);
				setStopCopyingModel(false);
				handleCalculationMaster();
				window.location.reload();
			} else {
				alertErrorMessage(result);
			};
		} catch (error) {
			alertErrorMessage(error);
		}
	};

	const handleAddInvestment = async (amount) => {

		if (!amount) {
			alertErrorMessage("Please enter a amount")
			return;
		}
		LoaderHelper.loaderStatus(true);
		try {
			const result = await AuthService.addInvestmentAmount(amount, masterSummeryData?.masterId);
			LoaderHelper.loaderStatus(false);
			if (result?.success) {
				alertSuccessMessage(result?.message);
				setAddInvestment(false);
				handleWalletBalance();
				handleCalculationMaster();
				setAddInvestAmount("");
				// window.location.reload();
			} else {
				alertErrorMessage(result);
			};
		} catch (error) {
			alertErrorMessage(error);
		}
	};

	const handeReduceAmount = async (amount, masterId) => {

		if (!amount) {
			alertErrorMessage("Please enter a amount")
			return;
		}
		LoaderHelper.loaderStatus(true);
		try {
			const result = await AuthService.reduceAmountdetail(amount, masterId);
			LoaderHelper.loaderStatus(false);
			if (result?.success) {
				alertSuccessMessage(result?.message);
				setReduceInvestment(false);
				handleWalletBalance();
				handleCalculationMaster();
				setReduceAmount("");
				window.location.reload();
			} else {
				alertErrorMessage(result);
			};
		} catch (error) {
			alertErrorMessage(error);
		}
	};

	useEffect(() => {
		handleCalculationMaster()
	}, []);

	const loadMore = () => {
		setMasterDataLength(prevCount => prevCount + 10);

	};

	useEffect(() => {
		// Scroll to the bottom after masterDataLength updates
		window.scrollTo({
			top: document.documentElement.scrollHeight,
			behavior: "smooth"
		});
	}, [masterDataLength]);

	const totalProfit = masterSummeryData?.totalProfit || 0;
	const totalLoss = masterSummeryData?.totalLoss || 0;
	const profitFactor = masterSummeryData?.profitFactor || 0;
	const total = totalProfit + totalLoss;
	const profitPercentage = total ? (totalProfit / total) * 100 : 0;
	const pathColor = totalProfit > totalLoss ? "green" : "red";

	const masterProfit = masterSummeryData?.master_profit_trades_count || 0;
	const masterTotalLoss = masterSummeryData?.master_loss_trades_count || 0;
	const profitFactorMaster = masterSummeryData?.profit_loss_sum || 0;
	const totalMaster = masterProfit + masterTotalLoss;
	const profitPercentageMaster = totalMaster ? (masterProfit / totalMaster) * 100 : 0;
	const pathColorMaster = masterProfit > masterTotalLoss ? "green" : "red";

	const masterBuy = masterSummeryData?.master_transaction_buy || 0;
	const masterSell = masterSummeryData?.master_transaction_sell || 0;
	const profitFactorBuysell = masterSummeryData?.master_transaction_buy + masterSummeryData?.master_transaction_sell || 0;
	const totalMasterBuySell = masterBuy + masterSell;
	const profitBuySell = totalMasterBuySell ? (masterBuy / totalMasterBuySell) * 100 : 0;
	const pathColorMasterBuySell = masterBuy > masterSell ? "green" : "red";

	const totalCurrencyCount = masterSummeryData?.currencyData?.reduce((total, item) => total + item.count, 0) || 0;



	return (
		<div class="wrapper saprate_page ">
			<div class=" page-body ">
				<div class="page-wrap">
					<Header />
					<div className="page_wrapper copier_wrapper" >
						<div className=" ct-header__top" >
							<div class="container">
								<div class="ct-header__inner">
									<h2 class="ct-header__name">
										Copy Trading
									</h2>
									<div class="ct-header__wallet">
										<div class="ct-wallet">
											<div class="ct-wallet__balance">
												<div class="ct-wallet__head"> Wallet balance </div>
												<div class="ct-wallet__count">
													<div class="ct-wallet__count-int"> ${formatNumber(wlletBalance?.balance?.toFixed(2) || 0)} </div>
													{/* <div class="ct-wallet__count-int"> ${formatNumber(wlletBalance?.balance || 0)} </div> */}
												</div>
											</div>
											{KycStatus === 2 &&
												<div class="ct-wallet__nav">
													<Link to="/withdraw" class="ct-wallet__withdrawal  btn btn-primary-light btn-sm">
														Withdrawal
													</Link>
													<Link to="/deposit" class="ct-wallet__deposit btn btn-primary btn-sm">
														Deposit
													</Link>
												</div>
											}
										</div>
									</div>
								</div>

								<div className="page_tabs" >
									<div class="nav nav-tabs" id="nav-tab" role="tablist">
										<Link class={`nav-link ${location?.pathname === "/copy_trading" && "active"}`} id="nav-Rating-tab" to="/copy_trading" >Rating</Link>
										<Link class={`nav-link ${location?.pathname === "/copier_area" && "active"}`} id="nav-Copier-tab" to={KycStatus === 2 ? "/copier_area" : "update_kyc"} >Copier Area </Link>
										<Link class={`nav-link ${location?.pathname === "/terms_conditions" && "active"}`} id="nav-tandc-tab" to="/terms_conditions" >Terms & Conditions</Link>
									</div>
								</div>
							</div>
						</div>

						<div className="page_wrapper " >
							<div className="container" >
								<div class="row g-3">
									<div class="col-lg-12">
										<div class="card bal_card_main master_profile_card">
											<div className="card-body" >
												<div className="row g-md-5" >
													<div className="col-lg-4" >
														<div className="tr_data">
															<div className="tr_profile tr_profile_xl" >
																<img className="tr_img" src={ApiConfig?.url + userDetails?.user_image || "/assets/images/NEWUSER.jpeg"} alt=""
																	onError={(e) => {
																		e.target.onerror = null;
																		e.target.src = "/assets/images/NEWUSER.jpeg";
																	}}
																/>
																<div className="tr_text" >
																	<span> {userDetails?.name} </span>
																	{/* <span> {countryFlag?.flag + " " + countryFlag?.name} </span> */}
																	<span> <small>{userDetails?.user_unique_code}</small> </span>

																</div>
															</div>
														</div>
													</div>
													<div className="col-lg-8" >
														<div className="row_recw" >
															<div className="col_recw" >
																<p className="text-muted mb-2"> Profit </p>
																<span className={`fw-bold ${userProfitLoss?.userTotalProfit > 0 ? "text-success" : "text-danger"}`} >  ${userProfitLoss?.userTotalProfit?.toFixed(2) || '0.00'}   </span>
																{/* <span className={`fw-bold ${userProfitLoss?.userTotalProfit > 0 ? "text-success" : "text-danger"}`} >  ${userProfitLoss?.userTotalProfit || 0}   </span> */}
															</div>
															<div className="col_recw" >
																<p className="text-muted mb-2"> Equity⁠  </p>
																<span className="fw-bold" >  ${userProfitLoss?.userEquity?.toFixed(2) || '0.00'}  </span>
																{/* <span className="fw-bold" >  ${userProfitLoss?.userEquity || 0}  </span> */}
															</div>
															<div className="col_recw" >
																<p className="text-muted mb-2"> User Gain  </p>
																{/* <span className={`fw-bold ${userProfitLoss?.user_gain > 0 ? "text-success" : "text-danger"}`} >  {userProfitLoss?.user_gain?.toFixed(2) || 0}%  </span> */}
																<span className={`fw-bold ${userProfitLoss?.user_gain > 0 ? "text-success" : "text-danger"}`} >  {userProfitLoss?.user_gain || '0.00'}%  </span>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>

									{/* Your progress with particular Master	 */}
									<div class="col-lg-12">
										<div class="card bal_card_main">
											<div className="card-body" >
												<h6 className="mb-3" >Your Progress With Particular Master</h6>
												<div className="list_view trader_you_copy" >
													<div className="table_data mt-0" >
														<div className="table-responsive" >
															<table class="table">
																<tbody>
																	{userProfitLoss?.data?.length > 0 ?
																		userProfitLoss?.data?.map((item, index) => {
																			return (
																				<tr className={`alt ${activeMaster === index ? "active" : ""}`} key={index} onClick={() => {
																					setMasterSummeryData(item); setActiveMaster(index);
																				}}>

																					<td>
																						<div href="trader_details" className="tr_profile" >
																							<img className="tr_img" src={ApiConfig?.url + item?.master_image} alt="" />
																							<div className="tr_text" >
																								<span>{item?.masters_name} </span>
																							</div>
																						</div>
																					</td>
																					<td>
																						<div className="row_recw" >
																							<div className="col_recw" >
																								<p className="text-muted mb-2"> Profit </p>
																								<span className="fw-bold" > ${item?.totalProfit?.toFixed(2) || 0}  </span>
																								{/* <span className="fw-bold" > ${item?.totalProfit || 0}  </span> */}
																							</div>

																							<div className="col_recw" >
																								<p className="text-muted mb-2"> Gain  </p>
																								<span className="fw-bold" > {item?.totalGain || 0}%  </span>
																							</div>
																							<div className="col_recw" >
																								<p className="text-muted mb-2"> Commission⁠  </p>
																								<span className="fw-bold" >  
																									{item?.masters_commissions}%  
																									</span>
																							</div>
																							<div className="col_recw" >
																								<p className="text-muted mb-2"> Risk Score  </p>
																								<span className={`badge ${item.masters_risk_score >= 1 && item.masters_risk_score <= 2
																									? 'bg-green'
																									: item.masters_risk_score >= 3 && item.masters_risk_score <= 4
																										? 'bg-warning'
																										: 'bg-danger'
																									}`}  >
																									{item?.masters_risk_score} Risk
																								</span>
																							</div>
																						</div>
																					</td>
																				</tr>
																			);
																		}) :
																		<tr>
																			<td colSpan="6" className="text-center" >
																				<div className="favouriteData pt-5 pb-5">
																					No Data Found
																				</div>
																			</td>
																		</tr>
																	}
																</tbody>
															</table>
														</div>
													</div>
												</div>

												{
													userProfitLoss?.data?.length > 0 &&
													<div className="master_action">
														<button className="btn btn-primary btn-lg m-0" onClick={() => setAddInvestment(true)}>
															<i class="ri-add-circle-line me-2"></i>
															Add New Investment
														</button>
														<button className="btn btn-danger btn-lg m-0" onClick={() => setStopCopyingModel(true)}>
															<i class="ri-stop-fill me-2"></i>
															Stop Copying
														</button>
														<button className="btn btn-black btn-lg m-0" onClick={() => setReduceInvestment(true)}>
															$ Reduce Investment
														</button>
													</div>
												}

											</div>
										</div>
									</div>

									{/*   History content tab   */}
									<div class="col-lg-12">
										<div class="card bal_card_main h-100">
											<div className="card-body">
												<div className="d-flex">
													<div className="page_tabs">
														<div className="nav nav-tabs" id="nav-tab" role="tablist">
															<button
																className={`nav-link ${activeTab === "Summary" ? "active" : ""}`}
																id="nav-Summary-tab"
																data-bs-toggle="tab"
																type="button"
																role="tab"
																aria-controls="nav-Summary"
																aria-selected={activeTab === "Summary"}
																onClick={() => setActiveTab("Summary")}
															>
																Summary
															</button>
														</div>
													</div>
													<div className="page_tabs">
														<div className="nav nav-tabs" id="nav-tab" role="tablist">
															<button
																className={`nav-link ${activeTab === "history" ? "active" : ""}`}
																id="nav-history-tab"
																data-bs-toggle="tab"
																type="button"
																role="tab"
																aria-controls="nav-history"
																aria-selected={activeTab === "history"}
																onClick={() => { setActiveTab("history"); handleHistoryData(); }}
															>
																History
															</button>
														</div>
													</div>
												</div>
												<div class="tab-content" id="nav-tabContent">
													{activeTab === "Summary" && (
														<div class="tab-pane fade show active" id="nav-Summary" role="tabpanel" aria-labelledby="nav-Summary-tab">
															<div className="chart_area" >
																<div className="row" >
																	<div className="col-lg-3" >
																		<div className="pr_chart_card" >
																			<div className="pr_chart" >
																				<div className="chart_outer" >

																					{/* <div className="chart_content" > <span>{masterSummeryData?.profitFactor || 0.00}</span> </div> */}
																					<CircularProgressbar
																						value={profitPercentage}
																						text={profitFactor.toFixed(2)}
																						// text={profitFactor}
																						styles={buildStyles({
																							pathColor: pathColor,
																							textColor: "#000",
																							trailColor: "#dc3545",
																							backgroundColor: "#f8f9fa", // Optional: background color of the outer circle
																						})}
																					/>
																				</div>
																			</div>
																			<div className="chart_data" >
																				<span className="text-danger" >{masterSummeryData?.totalLoss || 0.00}</span> &nbsp; |  &nbsp;
																				<span className="text-success" >{masterSummeryData?.totalProfit || 0.00}</span>
																				<p className="mb-0" > PROFIT FACTOR </p>
																			</div>
																		</div>
																	</div>
																	<div className="col-lg-3" >
																		<div className="pr_chart_card" >
																			<div className="pr_chart" >
																				<div className="chart_outer" >
																					{/* <div className="chart_content" > <span>{masterSummeryData?.profit_loss_sum || 0.00}</span> </div> */}
																					<CircularProgressbar
																						value={profitPercentageMaster}
																						text={profitFactorMaster?.toFixed(2)}
																						styles={buildStyles({
																							pathColor: pathColorMaster,
																							textColor: "#000",
																							trailColor: "#dc3545",
																							backgroundColor: "#f8f9fa", // Optional: background color of the outer circle
																						})}
																					/>
																				</div>
																			</div>
																			<div className="chart_data" >
																				<span className=" text-end" >

																					<div className="text-success"  >{masterSummeryData?.master_profit_trades_count || 0.00}</div>
																					<p className="mb-0" > Profit</p> </span> &nbsp; |  &nbsp;

																				<span className="text-start " >
																					<div className="text-danger"  >{masterSummeryData?.master_loss_trades_count || 0.00}</div>
																					<p className="mb-0" > Loss</p>
																				</span>

																			</div>
																		</div>
																	</div>
																	<div className="col-lg-3" >
																		<div className="pr_chart_card" >
																			<div className="pr_chart" >
																				<div className="chart_outer" >
																					{/* 	<div className="chart_content" > <span>{masterSummeryData?.master_transaction_buy + masterSummeryData?.master_transaction_sell || 0}</span> </div> */}
																					<CircularProgressbar
																						value={profitBuySell}
																						text={profitFactorBuysell.toFixed(2)}
																						styles={buildStyles({
																							pathColor: pathColorMasterBuySell,
																							textColor: "#000",
																							trailColor: "#dc3545",
																							backgroundColor: "#f8f9fa", // Optional: background color of the outer circle
																						})}
																					/>
																				</div>
																			</div>
																			<div className="chart_data">
																				<span className=" text-end"> <div className="text-dark"  >{masterSummeryData?.master_transaction_buy || 0}</div>
																					<p className="mb-0" > Buy</p> </span> &nbsp; |  &nbsp;
																				<span className=" text-start" > <div className="text-dark"
																				>{masterSummeryData?.master_transaction_sell || 0}</div>
																					<p className="mb-0" > Sell</p> </span>

																			</div>
																		</div>
																	</div>
																	<div className="col-lg-3">
																		<div className="pr_chart_card">
																			<div className="pr_chart">
																				<div className="chart_outer">
																					<div className="chart_content">
																						{/* <span>
																						{masterSummeryData?.currencyData ?
																							masterSummeryData?.currencyData.reduce((total, item) => total + item.count, 0)
																							: 0.00
																						}
																					</span> */}
																					</div>
																					<CircularProgressbar
																						value={totalCurrencyCount}
																						text={totalCurrencyCount.toFixed(2)}
																						styles={buildStyles({
																							pathColor: totalCurrencyCount,
																							textColor: "#000",
																							trailColor: "#008000",
																							backgroundColor: "#008000", // Optional: background color of the outer circle
																						})}
																					/>
																				</div>
																			</div>
																			<div className="chart_data  ccl_row">
																				{masterSummeryData?.currencyData && masterSummeryData?.currencyData.map((item, index) => (
																					<div key={index} className="d-flex align-items-center pr_chart_card  justify-content-between ">
																						<p className="mb-0" >{item.currency}</p>
																						<div className="text-dark">
																							{item.count}
																						</div>
																					</div>
																				))}
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													)}
												</div>
												{/* histroy tab */}
												{activeTab === "history" && (
													<div className="tab-pane fade show active" id="pills-two" role="tabpanel" aria-labelledby="pills-two-tab">
														<div className="table-responsive" width="100%">
															{/* <DataTableBase columns={userHistoryColumns} data={masterHistoryData} pagination /> */}
															<table className="table masterHistory_thead">
																<thead className="">
																	<tr>
																		<th>#</th>
																		<th>ORDER ID</th>
																		<th>DATE/TIME</th>
																		<th>VOL</th>
																		<th>TYPE</th>
																		<th>SYMBOL</th>
																		<th>OPEN/CLOSE PRICE</th>
																		<th>COMMISSION</th>
																		<th >PROFIT</th>
																	</tr>
																</thead>
																<tbody className="masterHistory">
																	{masterHistoryData.slice(0, masterDataLength).map((item, subIndex) => {
																		return (
																			<tr className="alt" key={subIndex}>
																				{/* <td>
																					<div className="his_d">
																						{item?.up_and_down === "DOWN" ? (
																							<i className="ri-arrow-right-down-line bg-danger text-white"></i>
																						) : (
																							<i className="ri-arrow-right-up-line bg-green text-white"></i>
																						)}
																						<span>{item?.amount?.toFixed(2)}</span>
																						{item?.currency}
																					</div>
																				</td> */}
																				<td>{subIndex + 1}</td>
																				<td>{item?.order_id ? `#${item?.order_id}` : ""}</td>
																				<td>{item?.time}</td>
																				<td>{item?.quantity || ""}</td>
																				<td><span >{item?.transaction_type || ""}</span></td>
																				<td>{item?.currency || ""}</td>
																				<td>{item?.open_price || ""}<br />{item?.close_price || ""}</td>
																				<td>{item?.commission_rate ? `${item?.commission_rate * 100}%` : ""}</td>
																				<td><span className={`text-${item?.transaction_type === "WITHDRAWAL" ? "danger" : item?.transaction_type === "DEPOSIT" ? "success" : " "}`}>
																					{`${item?.transaction_type === "WITHDRAWAL" ? "-" : item?.transaction_type === "DEPOSIT" ? "+" : " "}`}	{item?.amount ? `$${item?.amount}` : item?.commission_to_master ?
																						<span className="text-danger">-${item?.commission_to_master} </span> : ""}
																				</span>
																				</td>

																			</tr>
																		)
																	})}

																</tbody>

																{masterHistoryData.length > masterDataLength && (
																	<tfoot>
																		<tr>
																			<td colSpan="9" className="text-center ">
																				<button onClick={loadMore} type="button" className="btn btn-success btn-xs mt-4">Load More</button>
																			</td>
																		</tr>
																	</tfoot>
																)}

															</table>
														</div>
													</div>
												)}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>


			{/* modal add money */}
			{
				addInvestment &&
				<>
					<div class="modal show d-block">
						<div class="modal-dialog modal-dialog-centered">
							<div class="modal-content">
								<div class="modal-header">
									<h5 class="modal-title" id="exampleModalLabel">  Adding Investment </h5>
									<button type="button" class="btn-close" onClick={() => setAddInvestment(false)}></button>
								</div>
								<div class="modal-body">
									<div class="form-group mb-3">
										<label> I Want to Invest Investment </label>
										<div class="input-relative">
											<input type="number" class="form-control" value={addInvestAmount} onChange={(e) => setAddInvestAmount(e.target.value)} /><span>$</span>
										</div>
									</div>
									<p className="" >Your investment with this Master Trader will total <b>${addInvestAmount}</b> </p>
									<button type="button" class="btn btn-primary btn-block w-100 btn-md" onClick={() => handleAddInvestment(addInvestAmount)}>   ADD INVESTMENT </button>
								</div>
							</div>
						</div>
					</div>
					<div className="modal-backdrop" ></div>
				</>

			}

			{/* modal_stop_investoment */}
			{
				stopCopyingModel &&
				<>
					<div class="modal show d-block">
						<div class="modal-dialog modal-dialog-centered">
							<div class="modal-content">
								<div class="modal-header">
									<h6>{masterSummeryData?.masters_name}</h6>
								</div>
								<div class="modal-body text-center ">
									<div class="modal-body text-center pt-0">
										<h3>Alert!</h3>
										<p>Are you sure?</p>
										<button type="button" class="btn btn-dark-light btn-block w-100 btn-md my-3" onClick={() => handleStopCopying(masterSummeryData?.masterId)}>   STOP COPYING </button>
										<button type="button" class="btn btn-primary btn-block w-100 btn-md" onClick={() => setStopCopyingModel(false)}>  CANCEL </button>
									</div>

								</div>
							</div>
						</div>
					</div>
					<div className="modal-backdrop" ></div>
				</>
			}

			{
				reduceInvestment &&
				<>
					<div class="modal show d-block">
						<div class="modal-dialog modal-dialog-centered">
							<div class="modal-content">
								<div class="modal-header">
									<h5 class="modal-title" id="exampleModalLabel">  Reduce Investment ({masterSummeryData?.masters_name}) </h5>
									<button type="button" class="btn-close" onClick={() => setReduceInvestment(false)}></button>
								</div>
								<div class="modal-body">
									<div class="form-group mb-3">
										<label> Amount</label>
										<div class="input-relative">
											<input type="number" class="form-control" value={reduceAmount} onChange={(e) => setReduceAmount(e.target.value)} /><span>$</span>
										</div>
									</div>
									<button type="button" class="btn btn-primary btn-block w-100 btn-md" onClick={() => handeReduceAmount(reduceAmount, masterSummeryData?.masterId)}>
										REDUCE INVESTMENT
									</button>
								</div>
							</div>
						</div>
					</div>
					<div className="modal-backdrop" ></div>
				</>

			}


		</div>
	)
}

export default CopierArea


